import $ from 'jquery'
import config from '@/configurations/config.js'

export default {
  open (self) {
    $(`#modal-${config.constants.MediaClassification.MapLayers}`).modal('show')
      .on('shown.bs.modal', function (e) {
        $('#txtname').focus()
      })
  }
}
